module.exports = __webpack_public_path__ + "img/wedss5.08f361e5.jpg";